// extracted by mini-css-extract-plugin
export var alt = "Amenities-module--alt--a3936";
export var amenity = "Amenities-module--amenity--bca71";
export var amenityContainer = "Amenities-module--amenityContainer--692ca";
export var centerDiv = "Amenities-module--centerDiv--16b78";
export var desktopOnly = "Amenities-module--desktopOnly--d8271";
export var main = "Amenities-module--main--23044";
export var mobileOnly = "Amenities-module--mobileOnly--eff61";
export var showMoreLessButton = "Amenities-module--showMoreLessButton--c9da9";
export var showMoreLessContainer = "Amenities-module--showMoreLessContainer--6ec02";
export var textLeft = "Amenities-module--textLeft--a8b98";
export var tile = "Amenities-module--tile--f15eb";
export var visuallyHidden = "Amenities-module--visuallyHidden--ad790";